import React, { type InputHTMLAttributes } from "react";
import type { FieldError } from "react-hook-form";
import { twMerge } from "tailwind-merge";

interface PaymentInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: FieldError;
  id?: string;
}

const PaymentInput = ({ label, disabled, error, id, ...rest }: PaymentInputProps) => {
  return (
    <div className="w-full">
      <label htmlFor={id}>
        <span className="block mb-1 font-semibold cursor-pointer">{label}</span>
        <input
          {...rest}
          id={id}
          disabled={disabled}
          className={twMerge("px-4 py-2 border border-black rounded w-full text-black", disabled && "bg-black/10")}
        />
      </label>
      {error && <p className="text-red-500">{error.message}</p>}
    </div>
  );
};

export default PaymentInput;
